<div>
  @if (!isEditing) {
    <div (click)="startEdit()" class="content">
      <div class="text">
        @if (!value) {
          <span class="placeholder">{{ placeholder }}</span>
        }
        @if (allowParagraphs) {
          <div class="pre-wrap">{{ value }}</div>
        } @else {
          {{ value }}
        }
      </div>
      <div matTooltip="Click to edit" class="edit-button" (click)="startEdit()">
        <mat-icon>edit</mat-icon>
      </div>
    </div>
  }
  <div
    class="editing"
    [ngClass]="{
      hidden: !isEditing,
    }"
    >
    <textarea
      matInput
      class="editable"
      type="text"
      name="value"
      maxlength="400"
      [placeholder]="placeholder"
      #editInput
      [(ngModel)]="pendingValue"
      (keydown.enter)="allowParagraphs ? null : confirmEdit()"
      (keydown.escape)="cancelEdit()"
    ></textarea>
    <div class="button-container">
      <button mat-button (click)="cancelEdit()">CANCEL</button>
      <button mat-button class="save" (click)="confirmEdit()">SAVE</button>
    </div>
  </div>
</div>
